import { render, staticRenderFns } from "./ControlProduccionHeader.vue?vue&type=template&id=874bc482&"
import script from "./ControlProduccionHeader.vue?vue&type=script&lang=js&"
export * from "./ControlProduccionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports